import { LIST_ITEMS_PER_PAGE_LIST } from '../../constants/constants';
import { TMachineServiceActions } from './machine-service.actions';
import { TMachineServiceState, TMachineServiceInfoActionType } from './machine-service.models';

export const intialState: TMachineServiceState = {
  machineServiceListingInfo: null,
  machineServiceListingPagination: { pageNo: 1, pageSize: LIST_ITEMS_PER_PAGE_LIST[0] },
};

export function machineServiceReducer(state = intialState, action: TMachineServiceActions): TMachineServiceState {
  switch (action.type) {
    case TMachineServiceInfoActionType.SetMachineServiceListPagination:
      return {
        ...state,
        machineServiceListingPagination: action.pagination,
      };
    case TMachineServiceInfoActionType.GetMachineServiceList:
      return {
        ...state,
        machineServiceListingInfo: null,
      };
    case TMachineServiceInfoActionType.GetMachineServiceListSuccess:
      return {
        ...state,
        machineServiceListingInfo: {
          res: action.res,
          fetchReason: action.fetchReason,
        },
      };
    default:
      return state;
  }
}
